import axios from './_nestAxios'

export const obtenerTodo = (idAlmacen) =>
  axios.get('/estanterias', { params: { idAlmacen: idAlmacen || undefined } })

export const obtenerxId = (id) => axios.get(`/estanterias/${id}`)

export const nuevo = (data) => axios.post('/estanterias', data)

export const actualizar = (id, data) => axios.put(`/estanterias/${id}`, data)

export const eliminar = (id) => axios.delete(`/estanterias/${id}`)
